// START_MODULE pages_main_sections_description_description_tsx
// START_CONTRACT
// PURPOSE: Preserve this module from the original Tomsk Data Science frontend.
// OPERATIONAL_CONTEXT: Imported by the public static React application.
// CONTRACT: Render the original description and image immediately without entrance animation.
// KEYWORDS: legacy-frontend, static-site, tomsk-data-science
// COMPLEXITY: 2
// END_CONTRACT
import React from 'react';

import { ContentSectionContainerCustom, DescriptionContentInnerWrapper, DescriptionImage } from './styled';

import FirstImage from 'assets/gallery/1.jpg';

import { Section } from 'routes/section';

const Description: React.FC = () => (
  <ContentSectionContainerCustom id={Section.DESCRIPTION}>
    <h4>Описание</h4>
    <DescriptionContentInnerWrapper>
      <div>
        <DescriptionImage src={FirstImage} />
      </div>
      <div>
        <p>
          <b>Tomsk Data Science </b>
          — это сообщество энтузиастов, увлеченных наукой о данных.
          Наши встречи предоставляют участникам платформу для обмена своим опытом,
          обсуждения последних тенденций и инноваций, а также для того, чтобы учиться на
          успехах и проблемах друг друга.
        </p>
        <p>
          На наших мероприятиях обычно проводятся презентации и выступления участников,
          охватывающие широкий круг тем связанных с наукой о данных.
          Мы также призываем участников делиться своими собственными взглядами и идеями,
          создавая среду для сотрудничества, способствующую росту и обучению.
        </p>
        <p>
          Мы стремимся создать гостеприимную среду для всех желающих,
          независимо от их образования, уровня опыта и сферы деятельности.

        </p>
        <p>
          Присоединяйтесь к нам на наших мероприятиях, чтобы пообщаться с
          профессионалами-единомышленниками, расширить свои знания и поделиться
          собственным опытом в мире Data Science!
        </p>
      </div>
    </DescriptionContentInnerWrapper>
  </ContentSectionContainerCustom>
);

export default Description;

// END_MODULE pages_main_sections_description_description_tsx
